import BaseGetters from '@/store/base/getters'
import DetailGetters from "@/store/base/detail/getters";
import DocumentsGetters from "@/store/base/documents/getters";
import ArchivesGetters from "@/store/base/archives/getters";

export default BaseGetters({
    getCurrentModuleResidents: state => state.currentModule?.residents ?? [],
}, [ArchivesGetters, DocumentsGetters, DetailGetters])